import { c as _c } from "react/compiler-runtime";
import React from "react";
import Link from "next/link";
import { cx } from "@/lib/tailwind-utils";
export interface TAndSFooterProps {
  className?: string;
  byText?: string;
}
export const TAndSFooter: React.FC<TAndSFooterProps> = t0 => {
  const $ = _c(12);
  const {
    byText,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("mt-4", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href="https://www.decodahealth.com/terms-conditions" className="font-bold capitalize text-primary" target="_blank" rel="noopener noreferrer">Terms of Service</Link>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link href="https://www.decodahealth.com/privacy-policy" className="font-bold capitalize text-primary" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== byText) {
    t4 = <p className="text-center">By {byText}, you agree to our{" "}{t2}{" "}and{" "}{t3}.</p>;
    $[4] = byText;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="text-center text-caption">You consent to receive SMS messages for verification codes, appointment reminders, billing, and account updates. Standard message and data rates may apply.</p>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <div className="flex flex-col items-center space-y-4 text-caption leading-4 !text-black/80 sm:text-body">{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t1 || $[10] !== t6) {
    t7 = <div className={t1}>{t6}</div>;
    $[9] = t1;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};